import { guideSteps, safetyTips } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-book-open-line"></i>
              使用教程
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
              四步上手樱桃视频
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              无论是第一次访问，还是地址变化后重新找回入口，按照下面四个步骤操作即可顺畅使用。
            </p>
          </div>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {guideSteps.map((step) => (
              <div
                key={step.step}
                className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 flex flex-col"
              >
                <span className="font-heading text-2xl font-bold text-primary-500">{step.step}</span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{step.desc}</p>
              </div>
            ))}
          </div>

          <div id="safety" className="mt-16 md:mt-20 scroll-mt-24">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div className="max-w-2xl">
                <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                  <i className="ri-shield-check-line"></i>
                  安全提醒
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950">
                  安全与防骗须知
                </h2>
                <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  网络上存在仿冒入口，掌握以下要点可以帮你避开风险，安心使用。
                </p>
              </div>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
              {safetyTips.map((tip) => (
                <div
                  key={tip.title}
                  className="rounded-lg bg-background-50 border border-background-200/70 p-5 md:p-6 flex gap-4"
                >
                  <span className="w-11 h-11 shrink-0 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                    <i className={`${tip.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{tip.title}</h3>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{tip.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}